import { radar } from "@/utils/weblogger";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import {
    locale,
    Button,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Drawer,
    Menu,
    Submenu,
    MenuItem,
    Input,
    Form,
    FormItem,
    Select,
    DatePicker,
    Table,
    TableColumn,
    Upload,
    Dialog,
    Tooltip,
    Loading,
    Cascader,
    Pagination,
    Option,
    Breadcrumb,
    BreadcrumbItem,
    Step,
    Steps,
    Radio,
    RadioGroup,
    Checkbox,
    CheckboxGroup,
    Progress,
    InputNumber,
    Alert,
    Tag,
    Collapse,
    CollapseItem,
    Popover,
    Tabs,
    TabPane,
    Divider,
    Link,
} from "@ks/kwai-ui";
import "@ks/kwai-ui/lib/theme-new-era/base.css";
import lang from "@ks/kwai-ui/lib/locale/lang/zh-CN";

locale(lang);

const app = createApp(App);
const pinia = createPinia();
app.use(router)
    .use(pinia)
    .use(Button)
    .use(Dropdown)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Menu)
    .use(Submenu)
    .use(MenuItem)
    .use(Input)
    .use(Form)
    .use(FormItem)
    .use(Select)
    .use(DatePicker)
    .use(Table)
    .use(TableColumn)
    .use(Upload)
    .use(Dialog)
    .use(Loading)
    .use(Cascader)
    .use(Pagination)
    .use(Option)
    .use(Breadcrumb)
    .use(BreadcrumbItem)
    .use(Step)
    .use(Steps)
    .use(Radio)
    .use(Tooltip)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Progress)
    .use(InputNumber)
    .use(Alert)
    .use(Progress)
    .use(RadioGroup)
    .use(Tag)
    .use(Collapse)
    .use(CollapseItem)
    .use(Drawer)
    .use(Popover)
    .use(Tabs)
    .use(TabPane)
    .use(Divider)
    .use(Link);
app.mount("#app");

// 主动上报已捕获的异常
const prevErrorHandler = app.config.errorHandler;
app.config.errorHandler = function (error, vm, info) {
    radar.captureException(error as Error);
    if (prevErrorHandler) {
        prevErrorHandler.call(this, error, vm, info);
    } else if (window.console) {
        window.console.error(error);
    }
};
